export default __webpack_public_path__ + "static/media/ecommWebsite.51f5cd75.png";